import React from 'react';

export function useStateWithCallback<T>(initialValue: T, callback: (value: T) => void): [T, (newValue: T, callback?: () => void) => void] {
    const [state, setState] = React.useState<T>(initialValue);
  
    const setStateWithCallback = React.useCallback((newValue: T, callback?: () => void) => {
        setState(newValue);
        if (callback) {
            callback();
        }
    }, []);
  
    React.useEffect(() => {
        callback(state);
    }, [state, callback]);
  
    return [state, setStateWithCallback];
}